window.addEventListener('load', function() {
  
    function initializeFlickityForAll() {
              document.querySelectorAll('.nosto-list-item .colorVariantCount').forEach(element => {
            if (!element.hasAttribute('data-count-updated')) {
              element.setAttribute('data-count-updated', 'true'); // Mark to prevent duplicate processing
              const value = element.textContent || "";
              const colorCount = value.split('|').length;
              if (colorCount > 1){ 
                element.textContent = `Colors +${colorCount - 1}`;
                element.style.opacity = 1;
              } else {
                element.textContent = ``;
              }
            }
        });
        var nostoLists = document.querySelectorAll('.nosto-list');
        nostoLists.forEach(function(nostoList, index) {
            var uniqueClassName = 'nosto-list-' + index;
            nostoList.classList.add(uniqueClassName);
            var flkty = new Flickity('.' + uniqueClassName, {
                cellAlign: 'left',
                contain: true
            });
        });
    }

    function wrapDivsWithAnchor() {
        const nostoContainers = document.querySelectorAll('.nosto-image-container');
        nostoContainers.forEach(container => {
            const productUrl = container.getAttribute('product-url');
            const anchor = document.createElement('a');
            anchor.setAttribute('href', productUrl);
            container.parentNode.insertBefore(anchor, container);
            anchor.appendChild(container);
        });
    }

    function handleWishListClick(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        const wishList = evt.target;
        const product = wishList.closest('.nosto-list-item');
        const wishlistbtn = wishList.closest('.wishlist');
       
        if (!product) return;

        const wishListObject = {
            "epi": product.getAttribute('data-variant-id'),
            "du": product.getAttribute('data-product-url'),
            "empi": product.getAttribute('data-product-id'),
            "iu": product.getAttribute('data-product-image-url')
        };

        const isSaved = wishList.classList.toggle('is-saved');
        const iconswitch = wishlistbtn.classList.toggle('is-saved');
        const action = isSaved ? 'addToWishList' : 'removeFromWishList';

        window._swat[action](wishListObject, function(r) {
            console.log('wishlist', isSaved ? 'added' : 'removed', r);
            theme.updateWishList();
        });
    }
  
    function checkNostoList() {
        var nostoList = document.querySelector('.nosto-list');
        if (!nostoList) {
            setTimeout(checkNostoList, 100);
            return;
        }

        const wishlistButtons = document.querySelectorAll('.wishlist');
        if (!wishlistButtons.length) return;

        wishlistButtons.forEach(function(button) {
            const empi = button.getAttribute('data-empi');
            const epi = button.getAttribute('data-epi');
            if (empi || epi) {

              const matching_arr = window.myWishList ? window.myWishList.filter(i => i.empi == empi || i.epi == epi) : [];
              if (matching_arr.length) button.classList.add('is-saved');
            }
            button.addEventListener('click', handleWishListClick);
        });

const cartDrawerButton = document.querySelector(".js-drawer-open-cart");

if (cartDrawerButton) {
    cartDrawerButton.addEventListener('click', () => {
        // Use MutationObserver to wait for .nosto-cart-el elements to load
        const nostoObserver = new MutationObserver((mutationRecords, nostoObserverInstance) => {
            const nostoCartElements = document.querySelectorAll('.nosto-cart-el');

            if (nostoCartElements.length > 0) {
                nostoObserverInstance.disconnect(); // Stop observing

                setTimeout(() => {
                    nostoCartElements.forEach(nostoCartElement => {
                        const upsellProductItems = nostoCartElement.querySelectorAll('.nosto-list-item');
                        upsellProductItems.forEach(upsellProduct => {
                            const upsellAddToCartButton = upsellProduct.querySelector('.atc-cart-nosto');
                            if (!upsellAddToCartButton) return;
                            
                            upsellAddToCartButton.addEventListener('click', function (event) {
                                if (upsellAddToCartButton.classList.contains('already-in-cart')) {
                                    cartDrawerButton.click();
                                }
                                event.stopPropagation();
                                event.preventDefault();
                                theme.SizeDrawer.open(event, upsellProduct.getAttribute('data-product-handle'));
                            });
                        });
                    });
                }, 700);
            }
        });

        // Start observing the DOM for changes
        nostoObserver.observe(document.body, { childList: true, subtree: true });
    });
}



        initializeFlickityForAll();
        wrapDivsWithAnchor();
        initializeSliderWhenDrawerIsOpen();
    }
    
function initializeSliderWhenDrawerIsOpen() {
    var cartDrawer = document.getElementById('CartDrawer');
    var isOpen = cartDrawer.classList.contains('drawer--is-open');

    document.querySelectorAll(".nosto-cart-el .nosto-list").forEach(slider => {
        var existingFlkty = Flickity.data(slider);

        if (isOpen && !existingFlkty) {
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                prevNextButtons: false
            });
        } else if (!isOpen && existingFlkty) {
            existingFlkty.destroy();
        }
    });
}

     
    function handleMutations(mutationsList, observer) {
      
        mutationsList.forEach(mutation => {
            if (mutation.type === 'childList') {

                initializeSliderWhenDrawerIsOpen();
            }
        });
    }
    
    var observerOptions = {
        childList: true,
        subtree: true
    };
    
    var observer = new MutationObserver(handleMutations);
    
    var cartDrawer = document.getElementById('CartDrawer');
    observer.observe(cartDrawer, observerOptions);
    initializeSliderWhenDrawerIsOpen();
    checkNostoList();
  
    const ccartButton = document.querySelector(".js-drawer-open-cart");
    if (ccartButton) {
        ccartButton.addEventListener('click', function() {
          theme.cart.getCart().then((cart) => {
            document.getElementById('cart-item-count').textContent = cart.item_count; 
          });
            // Initialize the slider when the cart drawer is opened
            initializeSliderWhenDrawerIsOpen();
        });
    }
});

// function applyCategoryDiscounts() {
//     const discountBox = document.querySelector('.logged-in-discounts-box-overview-page');

//     if (!discountBox) {
//       console.log('Discount box element not found.');
//       return; // Stop execution if discount box is not present
//     }

//     const discountData = {};
//     const discountIdElements = discountBox.querySelectorAll('[class^="discount-ids-"]');

//     discountIdElements.forEach(idElement => {
//       const indexMatch = idElement.className.match(/discount-ids-(\d+)/);
//       if (indexMatch && indexMatch[1]) {
//         const index = indexMatch[1];
//         const ids = idElement.textContent.trim().split(',').map(id => id.trim());
//         const percentageElement = discountBox.querySelector(`.discount-percentage-${index}`);
//         const titleElement = discountBox.querySelector(`.discount-title-${index}`);

//         if (percentageElement && titleElement) {
//           const percentage = parseFloat(percentageElement.textContent);
//           console.log('Discount Percentage:', percentage);
//           const title = titleElement.textContent.trim();
//           console.log('Discount Title:', title);
//           ids.forEach(id => {
//             discountData[id] = { percentage: percentage, title: title };
//           });
//         }
//       }
//     });

//     function processNostoItems() {
//       const nostoListItems = document.querySelectorAll('.nosto-recs-cart .nosto-list-item');
//       let allNostoItemsProcessed = true;

//       if (nostoListItems.length === 0) {
//         // If no Nosto items are found yet, we might need to wait longer
//         allNostoItemsProcessed = false;
//       }

//       nostoListItems.forEach(item => {
//         if (!item.dataset.productCategoriesProcessed) {
//           // Check if the item already has a discounted price
//           const existingDiscountedPrice = item.querySelector('.nosto-newprice');

//           if (!existingDiscountedPrice) {
//             const categoryIdsString = item.dataset.productCategories;
//             if (categoryIdsString) {
//               const itemCategoryIds = categoryIdsString.split(',').map(id => id.trim());
              
//               const gridPriceElement = item.querySelector('.grid-product__price');

         
//               console.log('Grid Price Element:', gridPriceElement);

//               if (gridPriceElement) {
//                 const originalPriceText = gridPriceElement.textContent.trim();
//                 const originalPriceMatch = originalPriceText.match(/[\d.,]+/);
//                 let originalPrice = parseFloat(originalPriceMatch ? originalPriceMatch[0].replace(',', '.') : NaN);

//                 if (!isNaN(originalPrice)) {
//                   let bestDiscount = null;

//                   itemCategoryIds.forEach(categoryId => {
//                     if (discountData[categoryId]) {
//                       if (!bestDiscount || discountData[categoryId].percentage > bestDiscount.percentage) {
//                         bestDiscount = discountData[categoryId];
//                       }
//                     }
//                   });

//                   if (bestDiscount) {
//                     const discountedPrice = originalPrice * (1 - bestDiscount.percentage / 100);
//                     gridPriceElement.innerHTML = `
//                       <span class="search-result__price money grid-product__price price" style="color: #c1132c ;font-weight: 500;line-height: 14.4px; padding-right:1px;">$${discountedPrice.toFixed(2)}</span>
//                       <span class="search-result__price money grid-product__price price" style=" text-decoration: line-through;color: #999999;padding-left:4px;">$${originalPrice.toFixed(2)}</span>
//                       <div class="nosto-discount-banner">${bestDiscount.title}</div>
//                     `;
//                   } else {
//                     // If no discount applies, revert to the original price display
//                     gridPriceElement.innerHTML = `<span class="grid-product__price">${originalPriceText}</span>`;
//                   }
//                   item.dataset.productCategoriesProcessed = 'true'; // Mark this item as processed
//                 } else {
//                   console.log('Could not parse original price:', originalPriceText);
//                   allNostoItemsProcessed = false; // Consider it not fully processed if price is invalid
//                 }
//               } else {
//                 allNostoItemsProcessed = false; // Consider it not fully processed if price elements are missing
//               }
//             } else {
//               item.dataset.productCategoriesProcessed = 'true'; // Mark as processed if no categories
//             }
//           } else {
//             // If .nosto-newprice exists, the item is already discounted, so mark it as processed
//             item.dataset.productCategoriesProcessed = 'true';
//           }
//         }
//       });

//       if (!allNostoItemsProcessed) {
//         // If not all Nosto items are processed, wait and try again
//         setTimeout(processNostoItems, 500); // Check every 500ms
//       }
//     }

//     // Start processing Nosto items
//     processNostoItems();
//   }

//   // Initial call to start the process
//   applyCategoryDiscounts();